import { render } from "./ConsumableForm.vue?vue&type=template&id=a59f069c"
import script from "./ConsumableForm.vue?vue&type=script&lang=js"
export * from "./ConsumableForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__